<template>
  <v-container id="notificaciones" tag="section">
    <base-v-component :heading="title" />
    <base-material-card
      color="indigo"
      icon="mdi-bell-ring"
      inline
      class="px-5 py-3"
    >
      <v-card-text>
        <v-container>
          <v-layout wrap>
            <v-col cols="12">
              <v-text-field
                v-model="titulo"
                label="Título"
                :error-messages="tituloErrors"
                @input="$v.titulo.$touch()"
                @blur="$v.titulo.$touch()"
                ref="titulo"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-menu
                v-model="menuFecha"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :disabled="isEdit"
                    v-model="fecha"
                    label="Elija fecha de inicio"
                    prepend-icon="mdi-calendar"
                    readonly
                    @input="$v.fecha.$touch()"
                    @blur="$v.fecha.$touch()"
                    :error-messages="fechaErrors"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha"
                  @input="menuFecha = false"
                  :locale="langDefecto"
                  first-day-of-week="1"
                  label="Fecha inicio"
                  class="mt-4"
                  min="2020-04-17"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-menu
                ref="menu"
                v-model="menuHora"
                :disabled="isEdit"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="hora"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="hora"
                    :disabled="isEdit"
                    label="Elija la hora de inicio"
                    prepend-icon="mdi-av-timer"
                    :error-messages="horaErrors"
                    @input="$v.hora.$touch()"
                    @blur="$v.hora.$touch()"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  :locale="langDefecto"
                  format="24h"
                  v-if="menuHora"
                  :allowed-minutes="[0, 15, 30, 45]"
                  v-model="hora"
                  full-width
                  @click:minute="$refs.menu.save(hora)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                :disabled="isEdit"
                v-model="repeticiones"
                label="Nº Envíos"
                type="number"
                ref="repeticiones"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select
                v-model="cadencia"
                :disabled="isEdit"
                label="Cadencia"
                :items="$store.state.notificaciones.cadencia"
              ></v-select>
            </v-col>
            <v-row style="min-height: 300px">
              <v-col cols="12">
                <quill-editor
                  :content="content"
                  style="height: 200px"
                  :options="editorOption"
                  @change="onEditorChange($event)"
                ></quill-editor>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="mb-0">
                <v-btn
                  :disabled="isEdit"
                  class="primary"
                  @click="
                    restaurantes = $store.getters[
                      'restaurantes/getRestaurantesSelect'
                    ].map((r) => r.value)
                  "
                  >Todos</v-btn
                >
                <v-btn
                  :disabled="isEdit"
                  @click="restaurantes = []"
                  class="secondary"
                  >Ninguno</v-btn
                >
              </v-col>
              <v-col cols="12">
                <v-select
                  :disabled="isEdit"
                  v-model="restaurantes"
                  multiple
                  label="Restaurantes a enviar notificación"
                  :items="$store.getters['restaurantes/getRestaurantesSelect']"
                />
              </v-col>
            </v-row>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          :disabled="!saveBtnDisabled"
          @click="save"
          :loading="loadingForm"
          >Guardar</v-btn
        >
      </v-card-actions>
    </base-material-card>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState, mapGetters, mapActions } from "vuex";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import firebase from "firebase";
import moment from "moment";
import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    quillEditor,
  },
  mixins: [validationMixin],
  validations: {
    titulo: { required },
    fecha: { required },
    hora: { required },
  },
  data() {
    return {
      hora: "",
      menuHora: false,
      id: null,
      titulo: "",
      fecha: "",
      menuFecha: false,
      repeticiones: 1,
      cadencia: 24 * 60 * 60, //1 dia
      restaurantes: [],
      descripcionValidar: "",
      loadingForm: false,
      content: "",
      editorOption: {
        placeholder: "Escribe aquí...",
        readOnly: false,
        theme: "snow",
        // modules: {
        //     toolbar: [
        //         ['bold', 'italic', 'underline', 'strike'],
        //         ['blockquote'],
        //         [{ 'header': 1 }, { 'header': 2 }],
        //         [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        //         [{ 'script': 'sub'}, { 'script': 'super' }],
        //         [{ 'indent': '-1'}, { 'indent': '+1' }],
        //         [{ 'direction': 'rtl' }],
        //         [{ 'size': ['small', false, 'large', 'huge'] }],
        //         [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        //         [{ 'color': [] }, { 'background': [] }],
        //         [{ 'font': [] }],
        //         [{ 'align': [] }],
        //         ['clean']
        //       ]
        // },
      },
    };
  },
  computed: {
    title() {
      return this.isEdit
        ? "Editar Notificación " + this.id
        : "Nueva Notificación";
    },
    isEdit() {
      return this.id != null;
    },
    ...mapState({
      langDefecto: "langDefecto",
    }),
    ...mapGetters({
      negocio: "app/negocioGestObj",
    }),
    tituloErrors() {
      const errors = [];
      if (!this.$v.titulo.$dirty) return errors;
      !this.$v.titulo.required && errors.push("Título obligatorio.");
      return errors;
    },
    fechaErrors() {
      const errors = [];
      if (!this.$v.fecha.$dirty) return errors;
      !this.$v.fecha.required && errors.push("Fecha obligatoria.");
      return errors;
    },
    horaErrors() {
      const errors = [];
      if (!this.$v.hora.$dirty) return errors;
      !this.$v.hora.required && errors.push("Hora obligatoria.");
      return errors;
    },
    saveBtnDisabled() {
      return true;
    },
  },
  methods: {
    onEditorChange(event) {
      this.content = event.html;
    },
    save() {
      let _vm = this;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        _vm.loadingForm = true;
        var obj = {
          id: this.id,
          titulo: this.titulo,
          contenido: this.content,
        };
        if (!this.isEdit) {
          (obj.restaurantes = this.restaurantes),
            (obj.fechaInicio = firebase.firestore.Timestamp.fromDate(
              moment(this.fecha).toDate()
            ));
          obj.hora = firebase.firestore.Timestamp.fromDate(
            moment(this.fecha + " " + this.hora).toDate()
          );
          obj.fechaCreacion = firebase.firestore.Timestamp.now();
          obj.repeticiones = this.repeticiones;
          obj.cadencia = this.cadencia;
        }
        this.$store
          .dispatch("notificaciones/saveNotificacion", obj)
          .then((res) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Notificación añadida con éxito",
            });
            this.$router.push("/admin/negocio/notificaciones");
          })
          .catch((error) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al guardar la notificación: " + error,
            });
          })
          .finally(() => {
            _vm.loadingForm = false;
          });
      }
    },
  },
  created() {},
  async mounted() {
    this.id = this.$route.params.id_not ? this.$route.params.id_not : null;
    if (this.id) {
      let not = await this.$store.dispatch(
        "notificaciones/getNotificacion",
        this.id
      );
      this.titulo = not.titulo;
      this.cadencia = not.cadencia;
      this.repeticiones = not.repeticiones;
      this.fecha = moment(not.fechaInicio.toDate()).format("YYYY-MM-DD");
      this.hora = moment(not.hora.toDate()).format("HH:mm");
      this.restaurantes = not.restaurantes;
      this.content = not.contenido;
    }
  },
};
</script>

<style>
</style>